/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import guildApi from "apis/guildApi";
import userCreateRaceApi from "apis/userCreateRaceApi";
import { GetRaceListParams } from "models";
import { handleAsyncRequest } from 'utils/helper'

export const getListUserCreateRace  = createAsyncThunk(
  'userCreateRace/getListUserCreateRace',
  async (params?: GetRaceListParams) => {
    const [error, result] = await handleAsyncRequest(userCreateRaceApi.getListUserCreateRace(params))
    if (error) {
      return (error as any)?.message
    }
    return (result as any)?.data
  }
)

export const postUserCreateRace  = createAsyncThunk(
  'userCreateRace/postUserCreateRace',
  async (params?: any) => {
    const [error, result] = await handleAsyncRequest(userCreateRaceApi.postUserCreateRace(params))
    if (error) {
      return error
    }
    return result
  }
)

export const getRaceCreationLimit  = createAsyncThunk(
  'userCreateRace/getRaceCreationLimit',
  async () => {
    const [error, result] = await handleAsyncRequest(userCreateRaceApi.getRaceCreationLimit())
    if (error) {
      return (error as any)?.message
    }
    return (result as any)?.data
  }
)

export const getGuildRaceCreationLimit  = createAsyncThunk(
  'userCreateRace/getGuildRaceCreationLimit',
  async ({ guildId, region }: { guildId: number; region: string }) => {
    const [error, result] = await handleAsyncRequest(userCreateRaceApi.getGuildRaceCreationLimit(guildId, region))
    if (error) {
      return (error as any)?.message
    }
    return (result as any)?.data
  }
)

export const getGuildRaceFee  = createAsyncThunk(
  'userCreateRace/getGuildRaceFee',
  async () => {
    const [error, result] = await handleAsyncRequest(userCreateRaceApi.getGuildRaceFee())
    if (error) {
      return (error as any)?.message
    }
    return (result as any)?.data
  }
)

export const getFeeToCreateRace  = createAsyncThunk(
  'userCreateRace/getFeeToCreateRace',
  async () => {
    const [error, result] = await handleAsyncRequest(userCreateRaceApi.getFeeToCreateRace())
    if (error) {
      return (error as any)?.message
    }
    return (result as any)?.data
  }
)

export const postUserCancelRace  = createAsyncThunk(
  'userCreateRace/postUserCancelRace',
  async (raceId?: any) => {
    const [error, result] = await handleAsyncRequest(userCreateRaceApi.postUserCancelRace(raceId))
    if (error) {
      return error
    }
    return (result as any)?.data
  }
)

export const getCoinList  = createAsyncThunk(
  'userCreateRace/getCoinList',
  async ({ guildId, params }: { guildId: string | number; params: any }) => {
    const [error, result] = await handleAsyncRequest(guildApi.getVaultCoinReward(guildId, params))
    if (error) {
      return (error as any)?.message
    }
    return (result as any)?.data
  }
)

export const getNftList  = createAsyncThunk(
  'userCreateRace/getNftList',
  async ({ guildId, params }: { guildId: string | number; params: any }) => {
    const [error, result] = await handleAsyncRequest(guildApi.getVaultNftReward(guildId, params))
    if (error) {
      return (error as any)?.message
    }
    return (result as any)?.data
  }
)

export const getNonNftList  = createAsyncThunk(
  'userCreateRace/getNonNftList',
  async ({ guildId, params }: { guildId: string | number; params: any }) => {
    const [error, result] = await handleAsyncRequest(guildApi.getVaultNonNftReward(guildId, params))
    if (error) {
      return (error as any)?.message
    }
    return (result as any)?.data
  }
)

export const getTicketList  = createAsyncThunk(
  'userCreateRace/getTicketList',
  async ({ guildId, params }: { guildId: string | number; params: any }) => {
    const [error, result] = await handleAsyncRequest(guildApi.getVaultTicketReward(guildId, params))
    if (error) {
      return (error as any)?.message
    }
    return (result as any)?.data
  }
)
